import { render, staticRenderFns } from "./BookingPositionInbox.vue?vue&type=template&id=0f1bf2f3&scoped=true&"
import script from "./BookingPositionInbox.vue?vue&type=script&lang=js&"
export * from "./BookingPositionInbox.vue?vue&type=script&lang=js&"
import style0 from "./BookingPositionInbox.vue?vue&type=style&index=0&lang=less&"
import style1 from "./BookingPositionInbox.vue?vue&type=style&index=1&id=0f1bf2f3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1bf2f3",
  null
  
)

export default component.exports